// extracted by mini-css-extract-plugin
export var attachment = "_i0-a";
export var emailContainer = "_i0-4";
export var emailContentPaddedContainer = "_i0-b";
export var emailHeader = "_i0-6";
export var emailIframe = "_i0-3";
export var emailInfoIcon = "_i0-9";
export var emailShortenedSummary = "_i0-e";
export var infoDropdown = "_i0-0";
export var infoRowBoundedContent = "_i0-d";
export var internal = "_i0-5";
export var merchant = "_i0-8";
export var messageInputContainer = "_i0-h";
export var normal = "_i0-7";
export var replyCard = "_i0-f";
export var subtleButton = "_i0-1";
export var subtleButtonIconContainer = "_i0-2";
export var toggleViewRepliesButton = "_i0-c";
export var wrappingText = "_i0-g";